import React from "react";
import PropTypes from "prop-types";

import Fieldset from "../../common/Fieldset";
import TextAreaInput from "../../common/TextAreaInput";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";

const BehoefteForm = (props) => {
	const {
		beoordelingscriteria,
		disabled,
		errors,
		onChange,
		validationMessageType
	} = props;

	const OMGEVINGSANALYSE_TOOLTIP = "Denk hierbij aan jouw bestaande en nieuwe gebruikers/sportclubs, de kwaliteit en multifunctionaliteit van de infrastructuur, de bezetting en gebruik van de huidige infrastructuur, blinde vlekken, de bevolkingsevolutie en sportparticipatie, schoolbevolking, sporttrends en andere aspecten.";

	return (
		<Fieldset title="Behoefte">
			<FieldsetSubHeader>Maak een omgevingsanalyse gerelateerd aan de te realiseren sportinfrastructuur.</FieldsetSubHeader>
			<TextAreaInput
				name="omgevingsAnalyse"
				label="Omgevingsanalyse (max. 15.000 tekens)"
				value={beoordelingscriteria.omgevingsAnalyse}
				onChange={onChange}
				size={12}
				height={4}
				disabled={disabled}
				tooltip={OMGEVINGSANALYSE_TOOLTIP}
				validationMessage={errors ? errors.omgevingsAnalyse : ''}
				validationMessageType={validationMessageType}
				maxLength={15000} />
			<FieldsetSubHeader>Toon aan hoe je inspeelt op de geïdentificeerde knelpunten en hoe de investering zal bijdragen aan het huidige en toekomstige sportlandschap in de regio.</FieldsetSubHeader>
			<TextAreaInput
				name="bijdrageAanSportlandschap"
				label="Bijdrage aan het huidige en toekomstige sportlandschap"
				value={beoordelingscriteria.bijdrageAanSportlandschap}
				onChange={onChange}
				size={12}
				height={3}
				disabled={disabled}
				validationMessage={errors ? errors.bijdrageAanSportlandschap : ''}
				validationMessageType={validationMessageType}
				maxLength={3000} />
		</Fieldset>
	);
};

// ----------------------------------------------------------------------------
BehoefteForm.propTypes = {
	beoordelingscriteria: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	onChange: PropTypes.func.isRequired,
	validationMessageType: PropTypes.string
};

export default BehoefteForm;
